export const SCALAR_API_VERSION = "1.1";